export enum WorkListFilter {
    closedRequests = 'closedRequests',
    colleagueRequests = 'colleagueRequests',
    myRequests = 'myRequests',
    ongoingRequests = 'ongoingRequests',
    patientTasks = 'patientTasks',
}
